import { siteData } from "../data/mock";
import { Smile, Moon, Heart, ChevronRight, MessageCircle } from "lucide-react";

const iconMap = {
  "Ortodontia": Smile,
  "DTM": Moon,
  "Clínica Geral": Heart,
};

export const SpecialtiesSection = () => {
  return (
    <section id="especialidades" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-3">
            Tratamentos Especializados
          </h2>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">
            Cuidamos do seu sorriso com tratamentos personalizados e tecnologia de ponta
          </p>
        </div>

        {/* Specialties Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {siteData.specialties.map((specialty) => {
            const Icon = iconMap[specialty.category] || Smile;
            return (
              <div
                key={specialty.id}
                className="rounded-xl bg-white border-2 border-slate-100 hover:border-[#85BCFF] transition-all duration-300 hover:shadow-lg group"
              >
                <div className="p-7">
                  {/* Icon box */}
                  <div
                    className="inline-flex items-center justify-center w-14 h-14 rounded-lg mb-5 transition-transform duration-300 group-hover:scale-110"
                    style={{ background: 'linear-gradient(135deg, #85BCFF 0%, #6aa8f0 100%)' }}
                  >
                    <Icon size={26} style={{ color: '#FEFEFE' }} />
                  </div>

                  <h3 className="text-xl font-bold text-slate-900 mb-4">
                    {specialty.category}
                  </h3>

                  <ul className="space-y-2.5">
                    {specialty.items.map((item, idx) => (
                      <li
                        key={idx}
                        className="flex items-center gap-2 text-sm text-slate-600"
                      >
                        <ChevronRight size={14} style={{ color: '#85BCFF' }} />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA after specialties */}
        <div className="text-center mt-12">
          <a
            href={siteData.brand.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-lg text-base font-bold transition-all duration-200 hover:scale-105 hover:shadow-lg"
            style={{ backgroundColor: '#85BCFF', color: '#1F1F1F' }}
          >
            <MessageCircle size={18} />
            Agendar Consulta
          </a>
        </div>
      </div>
    </section>
  );
};
